import { takeLatest } from 'redux-saga/effects';

import { ON_EVENTS_MOUNT, ON_EVENTS_MOUNT_ERROR } from '../actions';

import { onEventsMount, redirectToHomepage } from './sagas';

export function* onMyEventsMountWatcher() {
  yield takeLatest(ON_EVENTS_MOUNT, onEventsMount);
}

export function* redirectToHomepageOnEventsMountError() {
  yield takeLatest(ON_EVENTS_MOUNT_ERROR, redirectToHomepage);
}



// WEBPACK FOOTER //
// ./src/modules/my-events/actions/watchers.js